import React, { forwardRef } from "react";
import { Row, Col, Avatar, Typography, Empty } from "antd";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { useLocation } from "react-router-dom";
import moment from "moment";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import { getFullName } from "../../../components/util/helpers";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import FormHeader from "../../../components/forms/FormHeader";
const { Text } = Typography;

const AssociatedPatient = forwardRef((props, ref) => {
  const { activeEmployee } = props;
  let location = useLocation();
  const associatedPatients =
    activeEmployee.foreign_worker_associations &&
    activeEmployee.foreign_worker_associations.length > 0
      ? activeEmployee.foreign_worker_associations
      : null;
  const getLetter = (patient) =>
    patient.first_name ? patient.first_name.charAt(0) : "";
  const getName = (patient) =>
    getFullName(patient.surename, patient.first_name);
  const isAdmin = location.pathname.includes("admin");
  const getLinkPath = (patient) =>
    isAdmin
      ? `/admin/patients/${patient.id}`
      : patient && `/branches/${patient.branch}/patients/${patient.id}`;
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.employees.associatedPatient" />}
        />
        {associatedPatients ? (
          associatedPatients.map((item) => (
            <>
              <Row>
                <Col>
                  <div style={{ paddingBottom: "20px" }}>
                    {item.patient.avatar_url ? (
                      <Avatar
                        className="avatar"
                        src={item.patient.avatar_url}
                      />
                    ) : (
                      <Avatar
                        className="avatar"
                        style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
                      >
                        {getLetter(item.patient)}
                      </Avatar>
                    )}
                    <Link
                      style={{ color: "inherit" }}
                      to={{
                        pathname: getLinkPath(item.patient),
                      }}
                    >
                      <Text
                        ellipsis={true}
                        style={{
                          padding: "0 10px",
                          textDecoration: "underline",
                        }}
                      >
                        {getName(item.patient)}
                      </Text>
                    </Link>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
                  <ResponsiveItemsWrapper>
                    <div style={{ flex: 1 }}>
                      <ReadOnlyItem
                        name="associated_patient.employment_license_number"
                        category="employee"
                        content={
                          item.employment_license_number
                            ? item.employment_license_number
                            : ""
                        }
                      />
                    </div>
                    <Spacer horizontal={true} />

                    <div style={{ flex: 1 }}>
                      <ReadOnlyItem
                        name="associated_patient.employment_license_expiration"
                        category="employee"
                        content={
                          item.employment_license_expiration
                            ? moment(item.employment_license_expiration).format(
                                "l"
                              )
                            : ""
                        }
                      />
                    </div>
                  </ResponsiveItemsWrapper>
                </Col>
              </Row>
            </>
          ))
        ) : (
          <Empty
            description={
              <Text>
                {<FormattedMessage id="app.employees.noAssociatedPatient" />}
              </Text>
            }
          />
        )}
      </Surface>
    </div>
  );
});

export default AssociatedPatient;
